import { Toast } from '@base-ui/react/toast';
import { CircleAlert, CircleCheck, Info, X } from 'lucide-react';
import Icon from '../primitives/Icon.jsx';

const TYPE_ICONS = { success: CircleCheck, error: CircleAlert, info: Info };

/**
 * Where toasts appear (bottom right). Any component adds one with
 * `Toast.useToastManager().add({ title, description, type })`; type is success, error or info.
 */
const ToastViewport = () => {
  const { toasts } = Toast.useToastManager();

  return (
    <Toast.Portal>
      <Toast.Viewport className="comp-toast-viewport">
        {toasts.map((toast) => (
          <Toast.Root key={toast.id} toast={toast} className="comp-toast">
            <span className="comp-toast__icon" data-type={toast.type}>
              <Icon icon={TYPE_ICONS[toast.type] ?? Info} />
            </span>
            <div className="comp-toast__text">
              <Toast.Title className="comp-toast__title" />
              <Toast.Description className="comp-toast__description" />
            </div>
            <Toast.Close className="comp-toast__close" aria-label="Dismiss">
              <Icon icon={X} size="sm" />
            </Toast.Close>
          </Toast.Root>
        ))}
      </Toast.Viewport>
    </Toast.Portal>
  );
};

export default ToastViewport;
